import tippy from "tippy.js";

$ ->
  if $('#js-presses, #js-preview_drafts').length > 0

    # 目次の開閉
    viewMoreContent = $('.js-viewmore-content')
    viewMoreOpen = $('.js-viewmore-open')
    viewMoreClose = $('.js-viewmore-close')

    viewMoreClose.hide()
    viewMoreOpen.on 'click', ->
      $(this).hide()
      viewMoreClose.css 'display', 'block'
      viewMoreContent.css 'display', 'block'
      viewMoreContent.animate { height: viewMoreContent.prop('scrollHeight') }
      return
    viewMoreClose.on 'click', ->
      $(this).hide()
      viewMoreOpen.css 'display', 'block'
      $('html, body').animate { scrollTop: $('.p-presses-show__toc-container').offset().top - 60 }, 200, 'swing', ->
        viewMoreContent.css 'display', 'inline-block'
        viewMoreContent.animate height: '120px', 200
      return

    # 目次へ戻るボタン
    returnTocLink = $('.js-return-toc')
    returnTocLink.on 'click', ->
      viewMoreOpen.hide()
      viewMoreClose.css 'display', 'block'
      viewMoreContent.css 'display', 'block'
      viewMoreContent.animate { height: viewMoreContent.prop('scrollHeight') }

    # 最後のパーツにクラスを付与
    $('.js-parts:last').addClass('p-presses-show__part-content--last')

    # ホテル比較表
    tippy '.js-popover',
      arrow: true
      animation: 'shift-away'
      delay: 300
      placement: 'bottom'
      trigger: 'click'
      theme: 'light'
